/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const XOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m18.75 5.25-13.5 13.5m13.5 0L5.25 5.25"
})));
// Fill
const XFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m13.06 11.98 6.22-6.22c.12-.14.18-.33.18-.51a.732.732 0 0 0-.23-.5.732.732 0 0 0-.5-.23.743.743 0 0 0-.51.18L12 10.92 5.78 4.7a.743.743 0 0 0-.51-.18c-.19.01-.37.09-.5.23-.14.13-.22.31-.23.5-.01.18.06.37.18.51l6.22 6.22-6.22 6.22c-.15.14-.22.33-.22.53s.07.39.22.53a.75.75 0 0 0 1.06 0L12 13.04l6.22 6.22a.75.75 0 0 0 1.06 0c.15-.14.22-.33.22-.53s-.07-.39-.22-.53l-6.22-6.22z"
})));
// DuoTone
const XDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m18.75 5.25-13.5 13.5m13.5 0L5.25 5.25"
})));
/**
  Icon XIcon in math group
*/
export const XIcon = createIcon('XIcon', 'x', 'math', XOutline, XFill, XDuotone, "0 0 24 24");